"use client";

import { useCallback } from "react";
import { UseFormReturn } from "react-hook-form";

import { FilterValues } from "@/app/(discover)/jobs/[stateName]/(state-jobs)/components/filters/filter-schema";
import { setPreferenceDefaultsOptOut } from "@/app/(discover)/jobs/[stateName]/(state-jobs)/components/filters/saved-search-and-preferences/preference-defaults.cookie";

export default function useResetFilters(
  form: UseFormReturn<FilterValues>,
  filterDefaults: FilterValues,
) {
  return useCallback(() => {
    setPreferenceDefaultsOptOut(true);
    form.reset(filterDefaults);
  }, [form, filterDefaults]);
}
